<template>
  <div>
      <h2>成绩查询</h2>
      <a-divider></a-divider>
      <iframe width="100%" height="800px" src="/cert/score.html" frameborder="no"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>